import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { getFontSize, getFontWeight } from "../../../../components/CustomText";
import CustomBoard from "../../../../components/CustomBoard";
import Color from "../../../../../utils/Color";
import "fontsource-muli";
import CustomOTP from "../../../../components/CustomOTP";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as selector from "../../../../../common/selectors";
import * as forgotUserIdSelector from "../../../../../common/selectors/auth";
import * as forgotUserIdAction from "../../../../../common/actions/auth";
import * as registrationAction from "../../../../../common/actions/registration";
import AuthManager from "../../../../../utils/AuthManager";

class ActivationPersonalOtpVerify extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nric: "",
      otp: "",
      height: 0,
      resendOtp: false,
      otpAction: false,
      localNric: "",
      localOtpRef: "",
      localUserID: "",
      localPassword: "",
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  async componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    await AuthManager.retrieveNric().then((value) => {
      if (value) {

        this.setState({ localNric: value });

      }
    });
    await AuthManager.retrieveOtpReference().then((value) => {
      if (value) {

        this.setState({ localOtpRef: value });

      }
    });
    await AuthManager.retrieveUserID().then((value) => {
      if (value) {

        this.setState({ localUserID: value });

      }
    });
    await AuthManager.retrievePassword().then((value) => {
      if (value) {

        this.setState({ localPassword: value });

      }
    });
  }

  componentDidUpdate() {
    const {
      activationGenericOtpVerifyData,
      activationGenericOtpVerifyStatus,
      activationGenericOtpVerifyLoading,
    } = this.props;
    if (
      activationGenericOtpVerifyData !== null &&
      activationGenericOtpVerifyStatus === true &&
      activationGenericOtpVerifyLoading === false && this.state.otpAction === true
    ) {
      const { history } = this.props;
      history.push("/ReceivedPersonalLinkOTP");
      this.setState({ otpAction: false })
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
    // AuthManager.removeNric();
    // AuthManager.removeReference();
    // AuthManager.removeUserID();
    // AuthManager.removePassword();
  }

  updateWindowDimensions() {
    this.setState({ height: window.innerHeight });
  }

  onChangeOTP = (event) => {
    this.setState({ otp: event.target.value });
  };

  onClickResend = async () => {
    //const { nric } = this.props.location.state;
    // this.setState({ resendOtp: true });
    // const { resendOtpRequest } = this.props;
    // resendOtpRequest(this.state.localNric);

    try {
      // Call reCAPTCHA API to get the token
      const recaptchaToken = await window.grecaptcha.execute(
        "6Lce7OMZAAAAALxOm9WwIETw1EL9UB73SDe4g0Tx",
        { action: "WEB_RESENDOTP" }
      );

      if (!recaptchaToken) {
        this.setState({
          //toastMessage: "User ID and Password can not be empty.",
          customToastStatus: true,
          toastMessage: "Unable to verify reCAPTCHA. Please try again.",
        });
        return;
      }

      this.setState({ resendOtp: true });
      const { resendOtpRequest } = this.props;
      resendOtpRequest(this.state.localNric, recaptchaToken);


    } catch (error) {
      this.setState({
        //toastMessage: "User ID and Password can not be empty.",
        customToastStatus: true,
        toastMessage: "Error during reCAPTCHA verification. Please try again.",
      });
    }
  };

  onClickVerify = () => {
    const {
      activationGenericOTPVerifyReq,
      resendOtpLoading,
      resendOtpData,
    } = this.props;
    //const { nric, otpReference, userID, password } = this.props.location.state;

    const resendOtpReference = forgotUserIdSelector.getResendOtpReference(
      resendOtpData
    );
    if (
      this.state.resendOtp === true &&
      resendOtpLoading === false &&
      resendOtpData !== null
    ) {
      activationGenericOTPVerifyReq(
        this.state.localNric,
        resendOtpReference,
        this.state.otp,
        this.state.localPassword,
        this.state.localUserID
      );
      return;
    } else {
      activationGenericOTPVerifyReq(
        this.state.localNric,
        //otpReference,
        this.state.localOtpRef,
        this.state.otp,
        this.state.localPassword,
        this.state.localUserID
      );
    }
    this.setState({ otpAction: true })
  };

  renderChildren = () => {
    const { otp } = this.state;
    return (
      <div>
        <CustomOTP
          otp={otp}
          onChangeOTP={this.onChangeOTP}
          onClickResend={this.onClickResend}
          onClickVerify={this.onClickVerify}
        />
      </div>
    );
  };

  render() {
    const { classes } = this.props;
    const { height } = this.state;
    return (
      <div className={classes.root}>
        <CustomBoard children={this.renderChildren()} height={height} />
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "white",
  },
  headerTextStyle: {
    ...getFontWeight("bold"),
    ...getFontSize("xxlarge"),
    textAlign: "left",
    color: "black",
  },
  labelTextInputTextStyle: {
    ...getFontWeight("bold"),
    ...getFontSize("large"),
    color: Color.primaryTextColor,
  },
  textInputContainer: {
    height: 40,
  },
  inputContainer: {
    marginTop: 40,
  },
  buttonStyle: {
    width: 120,
    marginTop: 30,
  },
});

function mapStateToProps(state) {
  return {
    activationGenericOtpVerifyData: selector.activationGenericOtpVerifyData(
      state
    ),
    activationGenericOtpVerifyLoading: selector.activationGenericOtpVerifyLoading(
      state
    ),
    activationGenericOtpVerifyStatus: selector.activationGenericOtpVerifyStatus(
      state
    ),
    resendOtpData: selector.resendOtpData(state),
    resendOtpLoading: selector.resendOtpLoading(state),
    resendOtpStatus: selector.resendOtpStatus(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    activationGenericOTPVerifyReq: (
      nric,
      otpReferenceNo,
      code,
      password,
      userID
    ) =>
      dispatch(
        registrationAction.activationGenericOTPVerifyReq(
          nric,
          otpReferenceNo,
          code,
          password,
          userID
        )
      ),
    resendOtpRequest: (userID, recaptchaToken) =>
      dispatch(forgotUserIdAction.resendOtpRequest(userID, recaptchaToken)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withStyles(styles, { withTheme: true })(
    withRouter(ActivationPersonalOtpVerify)
  )
);
